var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-breadcrumbs',{attrs:{"items":_vm.items},scopedSlots:_vm._u([{key:"item",fn:function(ref){
var item = ref.item;
return [_c('v-breadcrumbs-item',{attrs:{"to":item.to,"disabled":item.disabled,"exact":true}},[_vm._v(" "+_vm._s(item.text.toUpperCase())+" ")])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }